import React from 'react';
import PropTypes from 'prop-types';

import Button from 'zignal-landscape/lib/Button';
import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';
import Link from 'zignal-landscape/lib/Link';
import themeable from 'zignal-landscape/lib/themeable';
import {MODAL_STAGES} from '../../StoryAndSourceChecker.ducks';

const CheckerModalFooter = (props) => {
  const { modalStage, onCloseModal, onBackButtonClick, onNextButtonClick, isNextButtonDisabled } = props;

  let footerContent = null;
  switch (modalStage) {
    case MODAL_STAGES.search:
      footerContent = (
        <ButtonGroup align="right">
          <Link linkType="cancel" onClick={onCloseModal}>Cancel</Link>
          <Button
            buttonStyle="secondary"
            onClick={onNextButtonClick}
            disabled={isNextButtonDisabled}
          >Next</Button>
        </ButtonGroup>
      );
      break;
    case MODAL_STAGES.results:
      footerContent = (
        <ButtonGroup align="right">
          <Link linkType="cancel" onClick={onCloseModal}>Cancel</Link>
          <Button onClick={onBackButtonClick}>Back</Button>
          <Button buttonStyle="secondary" onClick={onCloseModal}>Done</Button>
        </ButtonGroup>
      );
      break;
    case MODAL_STAGES.resultDetail:
      footerContent = (
        <ButtonGroup align="right">
          <Link linkType="cancel" onClick={onCloseModal}>Cancel</Link>
          <Button onClick={onBackButtonClick}>Back</Button>
        </ButtonGroup>
      );
      break;
    default:
      throw new Error(`Unknown modal stage '${modalStage}'`);
  }

  return (
    <div>
      {footerContent}
    </div>
  );
};

CheckerModalFooter.propTypes = {
  modalStage: PropTypes.string,
  isNextButtonDisabled: PropTypes.bool,
  onCloseModal: PropTypes.func,
  onBackButtonClick: PropTypes.func,
  onNextButtonClick: PropTypes.func,
};

export default themeable(CheckerModalFooter);
